// Mock fixtures backing the Statistics page. These mirror the exact shapes the
// Statistics UI renders, so the eventual real endpoints just need to return the
// same JSON. The `stats` API module (../stats.js) serves these via `mock()`.

// ---------------------------------------------------------------------------
// Overall tab
// ---------------------------------------------------------------------------

// Cards across the top of the General section.
const overallTotalCards = [
  { id: 1, title: "Total Sales", total: "$112,325.54", sixWeekAvg: "$96,802.10" },
  { id: 2, title: "Total Orders", total: "1,247", sixWeekAvg: "1,102" },
  { id: 3, title: "Items Sold", total: "4,892", sixWeekAvg: "4,320" },
  { id: 4, title: "Average Sale", total: "$90.12", sixWeekAvg: "$87.84" },
];

// Customer Activity graph (General section).
const overallCustomerActivity = {
  activeDay: "Thu",
  data: [
    { day: "Mon", value: 22 },
    { day: "Tue", value: 27 },
    { day: "Wed", value: 24 },
    { day: "Thu", value: 35 },
    { day: "Fri", value: 26 },
    { day: "Sat", value: 27 },
    { day: "Sun", value: 29 },
  ],
};

// Line config for the per-category line graph (presentation, not series data).
const lineGraphLines = [
  { key: "hats", label: "Hats", color: "#91B6BB" },
  { key: "shirts", label: "Shirts", color: "#415364" },
  { key: "polos", label: "Polos", color: "#74531B" },
  { key: "quarterZips", label: "1/4 Zips", color: "#B16D03" },
];

const overallPie = [
  { label: "Books", value: 18372.67 },
  { label: "Office", value: 13320.32 },
  { label: "Clothing", value: 520.32 },
  { label: "Drinkware", value: 320.32 },
];

const categoryTabs = ["Books", "Clothing", "Office", "Drinkware"];

const categoryDataByKey = {
  Books: {
    lineGraphData: [
      { day: "Mon", hats: 30, shirts: 28, polos: 22, quarterZips: 18 },
      { day: "Tue", hats: 34, shirts: 32, polos: 24, quarterZips: 20 },
      { day: "Wed", hats: 28, shirts: 36, polos: 26, quarterZips: 22 },
      { day: "Thu", hats: 40, shirts: 38, polos: 30, quarterZips: 24 },
      { day: "Fri", hats: 42, shirts: 40, polos: 32, quarterZips: 26 },
      { day: "Sat", hats: 38, shirts: 34, polos: 28, quarterZips: 22 },
      { day: "Sun", hats: 35, shirts: 32, polos: 26, quarterZips: 20 },
    ],
    categoryPieData: [
      {
        id: "books-main",
        data: [
          { label: "Books", value: 18372.67 },
          { label: "Office", value: 1320.32 },
          { label: "Clothing", value: 520.32 },
          { label: "Drinkware", value: 320.32 },
        ],
      },
      {
        id: "books-secondary",
        data: [
          { label: "Books", value: 3320.32 },
          { label: "Office", value: 820.32 },
          { label: "Clothing", value: 420.32 },
          { label: "Drinkware", value: 220.32 },
        ],
      },
    ],
  },

  Clothing: {
    lineGraphData: [
      { day: "Mon", hats: 34, shirts: 30, polos: 28, quarterZips: 26 },
      { day: "Tue", hats: 28, shirts: 42, polos: 40, quarterZips: 20 },
      { day: "Wed", hats: 48, shirts: 34, polos: 22, quarterZips: 32 },
      { day: "Thu", hats: 32, shirts: 46, polos: 50, quarterZips: 18 },
      { day: "Fri", hats: 40, shirts: 52, polos: 24, quarterZips: 50 },
      { day: "Sat", hats: 26, shirts: 38, polos: 30, quarterZips: 28 },
      { day: "Sun", hats: 36, shirts: 44, polos: 36, quarterZips: 34 },
    ],
    categoryPieData: [
      {
        id: "clothing-main",
        data: [
          { label: "Books", value: 1320.32 },
          { label: "Office", value: 4320.32 },
          { label: "Clothing", value: 18372.67 },
          { label: "Drinkware", value: 520.32 },
        ],
      },
      {
        id: "clothing-secondary",
        data: [
          { label: "Books", value: 820.32 },
          { label: "Office", value: 2320.32 },
          { label: "Clothing", value: 9680.0 },
          { label: "Drinkware", value: 420.32 },
        ],
      },
    ],
  },

  Office: {
    lineGraphData: [
      { day: "Mon", hats: 20, shirts: 26, polos: 18, quarterZips: 16 },
      { day: "Tue", hats: 24, shirts: 30, polos: 20, quarterZips: 18 },
      { day: "Wed", hats: 26, shirts: 34, polos: 22, quarterZips: 20 },
      { day: "Thu", hats: 30, shirts: 38, polos: 26, quarterZips: 22 },
      { day: "Fri", hats: 32, shirts: 42, polos: 28, quarterZips: 24 },
      { day: "Sat", hats: 28, shirts: 36, polos: 24, quarterZips: 20 },
      { day: "Sun", hats: 26, shirts: 32, polos: 22, quarterZips: 18 },
    ],
    categoryPieData: [
      {
        id: "office-main",
        data: [
          { label: "Books", value: 3320.32 },
          { label: "Office", value: 12320.32 },
          { label: "Clothing", value: 820.32 },
          { label: "Drinkware", value: 420.32 },
        ],
      },
      {
        id: "office-secondary",
        data: [
          { label: "Books", value: 2320.32 },
          { label: "Office", value: 9320.32 },
          { label: "Clothing", value: 620.32 },
          { label: "Drinkware", value: 320.32 },
        ],
      },
    ],
  },

  Drinkware: {
    lineGraphData: [
      { day: "Mon", hats: 18, shirts: 20, polos: 16, quarterZips: 12 },
      { day: "Tue", hats: 22, shirts: 24, polos: 18, quarterZips: 14 },
      { day: "Wed", hats: 24, shirts: 28, polos: 20, quarterZips: 16 },
      { day: "Thu", hats: 28, shirts: 30, polos: 22, quarterZips: 18 },
      { day: "Fri", hats: 30, shirts: 34, polos: 24, quarterZips: 20 },
      { day: "Sat", hats: 26, shirts: 30, polos: 22, quarterZips: 18 },
      { day: "Sun", hats: 24, shirts: 28, polos: 20, quarterZips: 16 },
    ],
    categoryPieData: [
      {
        id: "drinkware-main",
        data: [
          { label: "Books", value: 320.32 },
          { label: "Office", value: 1320.32 },
          { label: "Clothing", value: 520.32 },
          { label: "Drinkware", value: 18372.67 },
        ],
      },
      {
        id: "drinkware-secondary",
        data: [
          { label: "Books", value: 220.32 },
          { label: "Office", value: 820.32 },
          { label: "Clothing", value: 420.32 },
          { label: "Drinkware", value: 9680.0 },
        ],
      },
    ],
  },
};

export const overall = {
  totalCards: overallTotalCards,
  customerActivity: overallCustomerActivity,
  lineGraphLines,
  overallPie,
  categoryTabs,
  categoryDataByKey,
};

// ---------------------------------------------------------------------------
// Single Item tab
// ---------------------------------------------------------------------------

// Searchable catalog used by the Single Item search box.
export const singleItemCatalog = [
  {
    id: "single-item-1",
    name: "WWG Mesh Hat",
    sku: "WWG-MESH-01",
    creator: "WWG Apparel",
    category: "Apparel",
  },
  {
    id: "single-item-2",
    name: "WWG Flatbrim Hat",
    sku: "WWG-FLAT-02",
    creator: "WWG Apparel",
    category: "Apparel",
  },
  {
    id: "single-item-3",
    name: "Long Sleeve Shirt",
    sku: "WWG-LS-03",
    creator: "WWG Apparel",
    category: "Apparel",
  },
  {
    id: "single-item-4",
    name: "15 Laws of Growth",
    sku: "BK-1501",
    creator: "John C. Maxwell",
    category: "Book",
  },
  {
    id: "single-item-5",
    name: "Mentor & Mentee",
    sku: "BK-1511",
    creator: "John C. Maxwell",
    category: "Book",
  },
  {
    id: "single-item-6",
    name: "Diamond Chips 2021",
    sku: "BK-1200",
    creator: "Various",
    category: "Media",
  },
];

// Per-item stats block. The mock returns the same figures for any selected
// item; the real endpoint would key these off the product id.
export const singleItem = {
  totals: [
    { id: "total-sales", title: "Total Sales", total: "$45,821.20", sixWeekAvg: "$38,240.50" },
    { id: "avg-order", title: "Avg. Order Value", total: "$82.45", sixWeekAvg: "$79.18" },
    { id: "units-sold", title: "Units Sold", total: "1,245", sixWeekAvg: "1,108" },
    { id: "inventory", title: "Inventory", total: "342", sixWeekAvg: "315" },
  ],
  customerActivity: {
    activeDay: "Thu",
    data: [
      { day: "Mon", value: 30 },
      { day: "Tue", value: 45 },
      { day: "Wed", value: 60 },
      { day: "Thu", value: 80 },
      { day: "Fri", value: 55 },
      { day: "Sat", value: 40 },
      { day: "Sun", value: 45 },
    ],
  },
  pie: [
    { label: "Books", value: 3320.32 },
    { label: "Office", value: 1320.32 },
    { label: "Clothing", value: 520.32 },
    { label: "Drinkware", value: 320.32 },
  ],
};

// ---------------------------------------------------------------------------
// Stock Report tab
// ---------------------------------------------------------------------------

const stockSalesDates = [
  "11/24/24",
  "12/1/24",
  "12/9/24",
  "12/17/24",
  "12/25/24",
  "1/2/25",
];

const stockWeeklySales = [12, 60, 15, 13, 16, 25];

const stockSalesByDate = stockSalesDates.map((date, index) => ({
  date,
  quantity: stockWeeklySales[index],
}));

const stockBaseRows = [
  {
    sku: "WWG-MESH-01",
    bin: "151",
    title: "White WWG Mesh Hat",
    available: "2",
  },
  {
    sku: "WWG-FLAT-02",
    bin: "151",
    title: "Black WWG Flatbrim Hat",
    available: "3",
  },
  {
    sku: "WWG-LS-03",
    bin: "151",
    title: "WWG Long Sleeve Shirt",
    available: "5",
  },
  {
    sku: "BK-1501",
    bin: "151",
    title: "The 15 Invaluable Laws of Growth",
    available: "8",
  },
];

export const stockReport = stockBaseRows.map((item, index) => ({
  ...item,
  salesByDate: stockSalesByDate,
  average: "45",
  onHand: "30",
  id: `stock-report-row-${index}`,
}));

const statsMock = { overall, singleItemCatalog, singleItem, stockReport };

export default statsMock;
